/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 *  The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** NULL_VALUE - Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
    NullValue["UNRECOGNIZED"] = "UNRECOGNIZED";
})(NullValue || (NullValue = {}));
//# sourceMappingURL=struct.enums.js.map